export class GetAllBanners {
    constructor() {
        this.handle = async () => {
            const apiUrl = process.env.REACT_APP_API_URL;
            try {
                const url = new URL(`/banners`, apiUrl);
                const response = await fetch(url.toString(), {
                    method: 'get',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
                const data = await response.json();
                return data;
            }
            catch (error) {
                return console.error(error);
            }
        };
    }
}
